// mutations
const SET_TEMPSKILL = (state, payload) => {
  state.temp_skill = payload;
};
const SET_USERID = (state, payload) => {
  state.user_id = payload;
};
const SET_IDSKILL = (state, payload) => {
  state.id_skill = payload;
};
const SET_RESSKILLBYID = (state, payload) => {
  state.res_sekillByID = payload;
};
export default {
  SET_RESSKILLBYID,
  SET_USERID,
  SET_TEMPSKILL,
  SET_IDSKILL
};
